import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { TopBarButton } from '../../elements';
import { SurveyListBulkUpdateModal } from './SurveyListBulkUpdateModal';

type SurveyListBulkUpdateButtonProps = {
    itemCount: number;
    surveyStatusOptions: { value: string; text: string }[];
    surveySearchQuery: Record<string, unknown>;
    reload(): void;
};

export function SurveyListBulkUpdateButton(props: SurveyListBulkUpdateButtonProps) {
    const translate = useTranslate();
    const [isOpen, setIsOpen] = React.useState(false);

    function open() {
        setIsOpen(true);
    }

    return (
        <>
            {isOpen && (
                <SurveyListBulkUpdateModal
                    itemCount={props.itemCount}
                    reload={() => props.reload()}
                    surveySearchQuery={props.surveySearchQuery}
                    surveyStatusOptions={props.surveyStatusOptions}
                    onClose={() => setIsOpen(false)}
                />
            )}

            <TopBarButton onClick={open} text={translate('common.bulkUpdate')} icon="fa-th-list" small />
        </>
    );
}
